import React from "react";

interface IProps {
  width?: number;
  height?: number;
  fill?: string;
  onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
  isAnimated?: boolean;
}

export const LoginIcon = ({
  width = 24,
  height = 24,
  fill = "var(--primary-color)",
}: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" id="password">
      <path
        fill={fill}
        d="M59,8H5A1,1,0,0,0,4,9V55a1,1,0,0,0,1,1H59a1,1,0,0,0,1-1V9A1,1,0,0,0,59,8ZM58,54H6V10H58Z"
        className="color1d1f47 svgShape"
      ></path>
      <path
        fill={fill}
        d="M36,35H28a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v5A3,3,0,0,1,36,35Zm-8-9a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
        className="color0055ff svgShape"
      ></path>
      <path
        fill={fill}
        d="M36 26H28a1 1 0 0 1-1-1V24a5 5 0 0 1 10 0v1A1 1 0 0 1 36 26zm-7-2h6a3 3 0 0 0-6 0zM32 31a1 1 0 0 1-1-1V29a1 1 0 0 1 2 0v1A1 1 0 0 1 32 31z"
        className="color0055ff svgShape"
      ></path>
      <path
        fill={fill}
        d="M59 8H5A1 1 0 0 0 4 9v8a1 1 0 0 0 1 1H20.08a1 1 0 0 0 .63-.22L25.36 14H59a1 1 0 0 0 1-1V9A1 1 0 0 0 59 8zm-1 4H25l-.21 0a1.09 1.09 0 0 0-.42.2L19.73 16H6V10H58zM50 49H14a1 1 0 0 1-1-1V39a1 1 0 0 1 1-1H50a1 1 0 0 1 1 1v9A1 1 0 0 1 50 49zM15 47H49V40H15z"
        className="color1d1f47 svgShape"
      ></path>
      <circle
        cx="19.5"
        cy="43.5"
        r="1.5"
        fill={fill}
        className="color0055ff svgShape"
      ></circle>
      <circle
        cx="24.5"
        cy="43.5"
        r="1.5"
        fill={fill}
        className="color0055ff svgShape"
      ></circle>
      <circle
        cx="29.5"
        cy="43.5"
        r="1.5"
        fill={fill}
        className="color0055ff svgShape"
      ></circle>
      <circle
        cx="34.5"
        cy="43.5"
        r="1.5"
        fill={fill}
        className="color0055ff svgShape"
      ></circle>
      <circle
        cx="39.5"
        cy="43.5"
        r="1.5"
        fill={fill}
        className="color0055ff svgShape"
      ></circle>
      <circle
        cx="44.5"
        cy="43.5"
        r="1.5"
        fill={fill}
        className="color0055ff svgShape"
      ></circle>
      <path
        fill={fill}
        d="M60 9a1 1 0 0 0-1-1H28.81l2.37-2.37A19.22 19.22 0 0 1 60 31zM35.19 56l-2.37 2.37A19.22 19.22 0 0 1 4 33V55a1 1 0 0 0 1 1z"
        opacity=".3"
        className="color0055ff svgShape"
      ></path>
    </svg>
  );
};

export const BriefcaseIcon = ({
  width = 24,
  height = 24,
  fill = "var(--primary-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <path
        d="M224,118.31V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V118.31h0A191.14,191.14,0,0,0,128,144,191.08,191.08,0,0,0,224,118.31Z"
        opacity="0.2"
      ></path>
      <path d="M104,112a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,112ZM232,72V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V72A16,16,0,0,1,40,56H80V48a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v8h40A16,16,0,0,1,232,72ZM96,56h64V48a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8ZM40,72v41.62A184.07,184.07,0,0,0,128,136a184,184,0,0,0,88-22.39V72ZM216,200V131.63A200.25,200.25,0,0,1,128,152a200.19,200.19,0,0,1-88-20.36V200H216Z"></path>
    </svg>
  );
};

export const PeopleIcon = ({
  width = 24,
  height = 24,
  fill = "var(--primary-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <path
        d="M136,108A52,52,0,1,1,84,56,52,52,0,0,1,136,108Z"
        opacity="0.2"
      ></path>
      <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"></path>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      height="14"
      width="14"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
      className="css-8mmkcg"
      fill={"#fff"}
    >
      <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
    </svg>
  );
};

export const DashboardIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill={fill}
    >
      <path
        d="M14 9C14 10.019 13.692 10.964 13.168 11.754L10.293 8.879C10.105 8.691 10 8.437 10 8.172V4.101C12.282 4.564 14 6.581 14 9ZM8 8.586V4.101C5.45 4.619 3.604 7.077 4.073 9.868C4.398 11.802 5.893 13.411 7.802 13.86C9.272 14.205 10.662 13.893 11.754 13.169L8.585 10C8.21 9.625 8 9.116 8 8.586ZM19 4H17C16.447 4 16 4.448 16 5C16 5.552 16.447 6 17 6H19C19.553 6 20 5.552 20 5C20 4.448 19.553 4 19 4ZM19 8H17C16.447 8 16 8.448 16 9C16 9.552 16.447 10 17 10H19C19.553 10 20 9.552 20 9C20 8.448 19.553 8 19 8ZM19 12H17C16.447 12 16 12.448 16 13C16 13.552 16.447 14 17 14H19C19.553 14 20 13.552 20 13C20 12.448 19.553 12 19 12ZM24 5V13C24 15.757 21.757 18 19 18H13V20H17C17.553 20 18 20.448 18 21C18 21.552 17.553 22 17 22H7C6.447 22 6 21.552 6 21C6 20.448 6.447 20 7 20H11V18H5C2.243 18 0 15.757 0 13V5C0 2.243 2.243 0 5 0H19C21.757 0 24 2.243 24 5ZM22 5C22 3.346 20.654 2 19 2H5C3.346 2 2 3.346 2 5V13C2 14.654 3.346 16 5 16H19C20.654 16 22 14.654 22 13V5Z"
        fill={fill}
      />
    </svg>
  );
};

export const UsersIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill={fill}
    >
      <path
        d="M7.5 13C6.60998 13 5.73995 12.7361 4.99993 12.2416C4.25991 11.7471 3.68314 11.0443 3.34254 10.2221C3.00195 9.39981 2.91283 8.49501 3.08647 7.6221C3.2601 6.74918 3.68868 5.94736 4.31802 5.31802C4.94736 4.68868 5.74918 4.2601 6.62209 4.08647C7.49501 3.91283 8.39981 4.00195 9.22208 4.34254C10.0443 4.68314 10.7471 5.25991 11.2416 5.99994C11.7361 6.73996 12 7.60999 12 8.5C11.9987 9.69307 11.5241 10.8369 10.6805 11.6805C9.83689 12.5241 8.69307 12.9987 7.5 13ZM7.5 6C7.00555 6 6.5222 6.14662 6.11107 6.42133C5.69995 6.69603 5.37952 7.08648 5.1903 7.54329C5.00108 8.00011 4.95157 8.50278 5.04804 8.98773C5.1445 9.47268 5.3826 9.91814 5.73223 10.2678C6.08186 10.6174 6.52732 10.8555 7.01227 10.952C7.49723 11.0484 7.99989 10.9989 8.45671 10.8097C8.91352 10.6205 9.30397 10.3001 9.57867 9.88893C9.85338 9.4778 10 8.99446 10 8.5C10 7.83696 9.73661 7.20108 9.26777 6.73223C8.79893 6.26339 8.16304 6 7.5 6ZM15 23V22.5C15 20.5109 14.2098 18.6032 12.8033 17.1967C11.3968 15.7902 9.48912 15 7.5 15C5.51088 15 3.60322 15.7902 2.1967 17.1967C0.790176 18.6032 0 20.5109 0 22.5L0 23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24C1.26522 24 1.51957 23.8946 1.70711 23.7071C1.89464 23.5196 2 23.2652 2 23V22.5C2 21.0413 2.57946 19.6424 3.61091 18.6109C4.64236 17.5795 6.04131 17 7.5 17C8.95869 17 10.3576 17.5795 11.3891 18.6109C12.4205 19.6424 13 21.0413 13 22.5V23C13 23.2652 13.1054 23.5196 13.2929 23.7071C13.4804 23.8946 13.7348 24 14 24C14.2652 24 14.5196 23.8946 14.7071 23.7071C14.8946 23.5196 15 23.2652 15 23ZM24 18C24 16.6487 23.6088 15.3263 22.8737 14.1924C22.1386 13.0585 21.091 12.1616 19.8574 11.61C18.6238 11.0584 17.2569 10.8756 15.9218 11.0837C14.5866 11.2919 13.3402 11.8821 12.333 12.783C12.2338 12.8702 12.1528 12.9762 12.0948 13.0949C12.0367 13.2135 12.0028 13.3425 11.9949 13.4744C11.987 13.6063 12.0053 13.7384 12.0487 13.8631C12.0922 13.9879 12.1599 14.1028 12.2481 14.2012C12.3362 14.2996 12.4429 14.3796 12.5621 14.4366C12.6813 14.4935 12.8106 14.5262 12.9426 14.5329C13.0745 14.5396 13.2064 14.5201 13.3308 14.4754C13.4551 14.4308 13.5694 14.362 13.667 14.273C14.3865 13.6296 15.2767 13.2082 16.2304 13.0597C17.1841 12.9111 18.1604 13.0417 19.0414 13.4358C19.9225 13.8299 20.6706 14.4705 21.1956 15.2804C21.7206 16.0903 22 17.0348 22 18C22 18.2652 22.1054 18.5196 22.2929 18.7071C22.4804 18.8946 22.7348 19 23 19C23.2652 19 23.5196 18.8946 23.7071 18.7071C23.8946 18.5196 24 18.2652 24 18ZM17.5 9C16.61 9 15.74 8.73608 14.9999 8.24162C14.2599 7.74715 13.6831 7.04434 13.3425 6.22208C13.0019 5.39981 12.9128 4.49501 13.0865 3.6221C13.2601 2.74918 13.6887 1.94736 14.318 1.31802C14.9474 0.688685 15.7492 0.260102 16.6221 0.0864683C17.495 -0.0871652 18.3998 0.00194979 19.2221 0.342544C20.0443 0.683138 20.7471 1.25991 21.2416 1.99994C21.7361 2.73996 22 3.60999 22 4.5C21.9987 5.69307 21.5241 6.83689 20.6805 7.68052C19.8369 8.52415 18.6931 8.99868 17.5 9ZM17.5 2C17.0055 2 16.5222 2.14662 16.1111 2.42133C15.7 2.69603 15.3795 3.08648 15.1903 3.54329C15.0011 4.00011 14.9516 4.50278 15.048 4.98773C15.1445 5.47268 15.3826 5.91814 15.7322 6.26777C16.0819 6.6174 16.5273 6.8555 17.0123 6.95197C17.4972 7.04843 17.9999 6.99892 18.4567 6.8097C18.9135 6.62048 19.304 6.30005 19.5787 5.88893C19.8534 5.4778 20 4.99446 20 4.5C20 3.83696 19.7366 3.20108 19.2678 2.73223C18.7989 2.26339 18.163 2 17.5 2Z"
        fill={fill}
      />
    </svg>
  );
};

export const CustomersIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill={fill}
    >
      <path
        d="M8 12C11.309 12 14 9.309 14 6C14 2.691 11.309 0 8 0C4.691 0 2 2.691 2 6C2 9.309 4.691 12 8 12ZM8 2C10.206 2 12 3.794 12 6C12 8.206 10.206 10 8 10C5.794 10 4 8.206 4 6C4 3.794 5.794 2 8 2ZM16 22V23C16 23.552 15.552 24 15 24C14.448 24 14 23.552 14 23V22C14 18.691 11.309 16 8 16C4.691 16 2 18.691 2 22V23C2 23.552 1.552 24 1 24C0.448 24 0 23.552 0 23V22C0 17.589 3.589 14 8 14C12.411 14 16 17.589 16 22ZM23.697 10.217L19.705 14.092C19.124 14.674 18.337 14.999 17.5 14.999C16.663 14.999 15.876 14.673 15.285 14.082L13.314 12.228C12.912 11.85 12.893 11.217 13.272 10.814C13.651 10.412 14.283 10.393 14.686 10.772L16.678 12.647C17.149 13.117 17.873 13.096 18.301 12.668L22.303 8.782C22.699 8.397 23.332 8.407 23.717 8.803C24.102 9.199 24.092 9.833 23.696 10.217H23.697Z"
        fill={fill}
      />
    </svg>
  );
};

export const CalendarIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill={fill}
    >
      <path d="M22.208,5.821c-.289-1.155-1.212-2.036-2.354-2.245-.333-.061-.668-.117-1.005-.17v-.932c0-.552-.448-1-1-1s-1,.448-1,1v.667c-3.193-.345-6.504-.345-9.697,0v-.667c0-.552-.448-1-1-1s-1,.448-1,1v.932c-.337,.053-.672,.109-1.005,.17-1.141,.208-2.065,1.089-2.354,2.244-1.062,4.246-1.062,9.521,0,13.768,.289,1.155,1.213,2.036,2.354,2.244,2.532,.462,5.193,.694,7.854,.694s5.321-.231,7.854-.694c1.141-.208,2.065-1.089,2.354-2.244,1.062-4.246,1.062-9.521,0-13.767Zm-17.702-.277c2.417-.441,4.955-.662,7.494-.662s5.078,.221,7.494,.662c.371,.067,.674,.367,.773,.762,.086,.345,.164,.699,.235,1.06H3.498c.071-.361,.149-.715,.235-1.06,.099-.395,.402-.694,.773-.762Zm15.761,13.559c-.099,.395-.402,.694-.773,.762-4.833,.883-10.155,.883-14.988,0-.371-.067-.674-.367-.773-.762-.732-2.925-.912-6.494-.543-9.737H20.81c.37,3.244,.189,6.812-.543,9.737Z" />
      <g>
        <circle cx="7.691" cy="13.002" r="1" fill={fill} />
        <circle cx="7.691" cy="16.736" r="1" fill={fill} />
        <circle cx="12.005" cy="12.994" r="1" fill={fill} />
        <circle cx="12.005" cy="16.728" r="1" fill={fill} />
        <circle cx="16.311" cy="12.994" r="1" fill={fill} />
        <circle cx="16.311" cy="16.728" r="1" fill={fill} />
      </g>
    </svg>
  );
};

export const OffersIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill={fill}
    >
      <path
        d="M0 18.5863C0 19.6543 0.416 20.6583 1.172 21.4143L2.586 22.8283C3.341 23.5843 4.346 24.0003 5.414 24.0003C6.482 24.0003 7.487 23.5843 8.243 22.8283L10.933 20.1383C11.324 19.7473 11.324 19.1153 10.933 18.7243C10.542 18.3333 9.91 18.3333 9.519 18.7243L6.829 21.4143C6.073 22.1703 4.756 22.1703 4 21.4143L2.586 20.0003C2.208 19.6223 2 19.1203 2 18.5863C2 18.0523 2.208 17.5503 2.586 17.1723L4.517 15.2403L5.932 16.6543C6.323 17.0453 6.955 17.0453 7.346 16.6543C7.737 16.2633 7.737 15.6313 7.346 15.2403L5.224 13.1193C4.833 12.7283 4.201 12.7283 3.81 13.1193L1.172 15.7583C0.416 16.5133 0 17.5173 0 18.5863ZM20.138 10.9333C19.943 11.1283 19.687 11.2263 19.431 11.2263C19.175 11.2263 18.919 11.1283 18.724 10.9333C18.333 10.5423 18.333 9.91034 18.724 9.51934L21.414 6.82934C21.792 6.45134 22 5.94934 22 5.41534C22 4.88134 21.792 4.37934 21.414 4.00134L20 2.58734C19.244 1.83134 17.927 1.83134 17.171 2.58734L15.239 4.51934L16.654 5.93334C17.045 6.32434 17.045 6.95634 16.654 7.34734C16.263 7.73834 15.631 7.73834 15.24 7.34734L13.118 5.22634C12.93 5.03834 12.825 4.78534 12.825 4.51934C12.825 4.25334 12.93 3.99934 13.118 3.81234L15.757 1.17334C17.268 -0.339657 19.903 -0.339657 21.414 1.17234L22.828 2.58634C23.584 3.34234 24 4.34634 24 5.41434C24 6.48234 23.584 7.48734 22.828 8.24234L20.138 10.9333ZM1.075 6.26934L17.05 22.2423C18.182 23.3763 19.689 24.0003 21.292 24.0003H23C23.552 24.0003 24 23.5533 24 23.0003V21.2923C24 19.6893 23.376 18.1833 22.243 17.0503L6.269 1.07534C4.838 -0.355657 2.508 -0.357657 1.076 1.07534C-0.355 2.50734 -0.355 4.83734 1.076 6.26834L1.075 6.26934ZM6.275 8.64034L8.64 6.27534L20.829 18.4643C21.584 19.2203 22 20.2243 22 21.2923V22.0003H21.292C20.223 22.0003 19.219 21.5843 18.464 20.8283L6.274 8.63934L6.275 8.64034ZM2.49 2.49034C3.142 1.83834 4.202 1.83934 4.855 2.49034L7.226 4.86134L4.861 7.22634L2.49 4.85534C1.839 4.20334 1.839 3.14234 2.49 2.49034Z"
        fill={fill}
      />
    </svg>
  );
};
export const SettingsIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill={fill}
    >
      <path
        d="M10.7967 8C10.0055 8 9.23218 8.2346 8.57438 8.67412C7.91659 9.11365 7.4039 9.73836 7.10115 10.4693C6.79839 11.2002 6.71918 12.0044 6.87352 12.7804C7.02786 13.5563 7.40883 14.269 7.96824 14.8284C8.52765 15.3878 9.24038 15.7688 10.0163 15.9231C10.7922 16.0775 11.5965 15.9983 12.3274 15.6955C13.0583 15.3928 13.683 14.8801 14.1225 14.2223C14.5621 13.5645 14.7967 12.7911 14.7967 12C14.7967 10.9391 14.3752 9.92172 13.6251 9.17157C12.8749 8.42143 11.8575 8 10.7967 8ZM10.7967 14C10.4011 14 10.0144 13.8827 9.68552 13.6629C9.35663 13.4432 9.10028 13.1308 8.9489 12.7654C8.79753 12.3999 8.75792 11.9978 8.83509 11.6098C8.91226 11.2219 9.10275 10.8655 9.38245 10.5858C9.66216 10.3061 10.0185 10.1156 10.4065 10.0384C10.7944 9.96126 11.1966 10.0009 11.562 10.1522C11.9275 10.3036 12.2398 10.56 12.4596 10.8889C12.6794 11.2178 12.7967 11.6044 12.7967 12C12.7967 12.5304 12.586 13.0391 12.2109 13.4142C11.8358 13.7893 11.3271 14 10.7967 14Z"
        fill={fill}
      />
      <path
        d="M20.0907 13.9L19.6467 13.644C19.8466 12.5564 19.8466 11.4416 19.6467 10.354L20.0907 10.098C20.4321 9.90102 20.7314 9.63871 20.9715 9.32606C21.2115 9.01341 21.3877 8.65654 21.4898 8.27582C21.592 7.8951 21.6181 7.49799 21.5668 7.10716C21.5155 6.71633 21.3877 6.33944 21.1907 5.998C20.9937 5.65656 20.7314 5.35727 20.4187 5.1172C20.1061 4.87714 19.7492 4.70101 19.3685 4.59886C18.9878 4.49672 18.5907 4.47056 18.1998 4.52189C17.809 4.57321 17.4321 4.70102 17.0907 4.898L16.6457 5.155C15.8052 4.43692 14.8393 3.88025 13.7967 3.513V3C13.7967 2.20435 13.4806 1.44129 12.918 0.87868C12.3554 0.31607 11.5923 0 10.7967 0C10.001 0 9.23796 0.31607 8.67535 0.87868C8.11274 1.44129 7.79667 2.20435 7.79667 3V3.513C6.75406 3.88157 5.78852 4.4396 4.94867 5.159L4.50167 4.9C3.81211 4.50218 2.99276 4.39457 2.22386 4.60086C1.45496 4.80715 0.799499 5.31044 0.401674 6C0.00384909 6.68956 -0.103754 7.50892 0.102536 8.27782C0.308826 9.04672 0.812111 9.70218 1.50167 10.1L1.94567 10.356C1.74578 11.4436 1.74578 12.5584 1.94567 13.646L1.50167 13.902C0.812111 14.2998 0.308826 14.9553 0.102536 15.7242C-0.103754 16.4931 0.00384909 17.3124 0.401674 18.002C0.799499 18.6916 1.45496 19.1948 2.22386 19.4011C2.99276 19.6074 3.81211 19.4998 4.50167 19.102L4.94667 18.845C5.78744 19.5632 6.75365 20.1199 7.79667 20.487V21C7.79667 21.7956 8.11274 22.5587 8.67535 23.1213C9.23796 23.6839 10.001 24 10.7967 24C11.5923 24 12.3554 23.6839 12.918 23.1213C13.4806 22.5587 13.7967 21.7956 13.7967 21V20.487C14.8393 20.1184 15.8048 19.5604 16.6447 18.841L17.0917 19.099C17.7812 19.4968 18.6006 19.6044 19.3695 19.3981C20.1384 19.1918 20.7938 18.6886 21.1917 17.999C21.5895 17.3094 21.6971 16.4901 21.4908 15.7212C21.2845 14.9523 20.7812 14.2968 20.0917 13.899L20.0907 13.9ZM17.5427 10.124C17.8813 11.3511 17.8813 12.6469 17.5427 13.874C17.4835 14.0876 17.497 14.3147 17.581 14.5198C17.665 14.7249 17.8147 14.8963 18.0067 15.007L19.0907 15.633C19.3205 15.7656 19.4882 15.9841 19.5569 16.2403C19.6257 16.4966 19.5898 16.7697 19.4572 16.9995C19.3246 17.2293 19.1061 17.397 18.8498 17.4658C18.5936 17.5345 18.3205 17.4986 18.0907 17.366L17.0047 16.738C16.8126 16.6267 16.5889 16.5826 16.3689 16.6124C16.1489 16.6423 15.9451 16.7445 15.7897 16.903C14.8996 17.8117 13.7782 18.46 12.5467 18.778C12.3317 18.8333 12.1412 18.9585 12.0053 19.1339C11.8693 19.3094 11.7956 19.525 11.7957 19.747V21C11.7957 21.2652 11.6903 21.5196 11.5028 21.7071C11.3152 21.8946 11.0609 22 10.7957 22C10.5305 22 10.2761 21.8946 10.0886 21.7071C9.90103 21.5196 9.79567 21.2652 9.79567 21V19.748C9.79578 19.526 9.72205 19.3104 9.58608 19.1349C9.45011 18.9595 9.25964 18.8343 9.04467 18.779C7.81302 18.4597 6.692 17.81 5.80267 16.9C5.6472 16.7415 5.44341 16.6393 5.22343 16.6094C5.00345 16.5796 4.77978 16.6237 4.58767 16.735L3.50367 17.362C3.3899 17.4287 3.26406 17.4722 3.1334 17.4901C3.00273 17.508 2.86983 17.4998 2.74233 17.4661C2.61483 17.4324 2.49526 17.3738 2.39049 17.2937C2.28573 17.2136 2.19785 17.1135 2.13191 16.9993C2.06597 16.8851 2.02327 16.759 2.00627 16.6282C1.98927 16.4974 1.99831 16.3646 2.03286 16.2373C2.06742 16.11 2.1268 15.9909 2.20761 15.8866C2.28841 15.7824 2.38903 15.6952 2.50367 15.63L3.58767 15.004C3.77962 14.8933 3.92935 14.7219 4.01333 14.5168C4.09732 14.3117 4.1108 14.0846 4.05167 13.871C3.71303 12.6439 3.71303 11.3481 4.05167 10.121C4.10974 9.90788 4.09561 9.68153 4.01149 9.47729C3.92737 9.27305 3.77799 9.10241 3.58667 8.992L2.50267 8.366C2.27286 8.23339 2.10514 8.01492 2.03641 7.75865C1.96768 7.50239 2.00357 7.22931 2.13617 6.9995C2.26878 6.76969 2.48725 6.60197 2.74352 6.53324C2.99979 6.46451 3.27286 6.50039 3.50267 6.633L4.58867 7.261C4.78025 7.37251 5.00345 7.41721 5.2232 7.38807C5.44295 7.35893 5.64678 7.25759 5.80267 7.1C6.69276 6.19134 7.8141 5.54302 9.04567 5.225C9.26131 5.16956 9.45227 5.04375 9.58831 4.8675C9.72435 4.69125 9.79767 4.47464 9.79667 4.252V3C9.79667 2.73478 9.90203 2.48043 10.0896 2.29289C10.2771 2.10536 10.5315 2 10.7967 2C11.0619 2 11.3162 2.10536 11.5038 2.29289C11.6913 2.48043 11.7967 2.73478 11.7967 3V4.252C11.7966 4.47396 11.8703 4.68964 12.0063 4.86508C12.1422 5.04052 12.3327 5.16573 12.5477 5.221C13.7797 5.54015 14.9011 6.18988 15.7907 7.1C15.9461 7.25847 16.1499 7.36069 16.3699 7.39057C16.5899 7.42044 16.8136 7.37626 17.0057 7.265L18.0897 6.638C18.2034 6.5713 18.3293 6.52777 18.4599 6.5099C18.5906 6.49204 18.7235 6.50019 18.851 6.5339C18.9785 6.56761 19.0981 6.6262 19.2029 6.70631C19.3076 6.78642 19.3955 6.88646 19.4614 7.00067C19.5274 7.11488 19.5701 7.24101 19.5871 7.37179C19.6041 7.50257 19.595 7.63542 19.5605 7.76269C19.5259 7.88997 19.4665 8.00915 19.3857 8.11337C19.3049 8.2176 19.2043 8.30482 19.0897 8.37L18.0057 8.996C17.8147 9.10671 17.6658 9.27748 17.582 9.48169C17.4983 9.68591 17.4844 9.9121 17.5427 10.125V10.124Z"
        fill={fill}
      />
    </svg>
  );
};

export const NoteIcon = ({
  width = 24,
  height = 24,
  fill = "var(--primary-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={fill}
    >
      <g clipPath="url(#clip0_322_641)">
        <path
          d="M25.3333 0H6.66667C2.98667 0 0 2.98667 0 6.66667V25.3333C0 29.0133 2.98667 32 6.66667 32H21.7867C23.5733 32 25.24 31.3067 26.5067 30.0533L30.0533 26.5067C31.3067 25.2533 32 23.5733 32 21.7867V6.66667C32 2.98667 29.0133 0 25.3333 0ZM6.66667 29.3333C4.46667 29.3333 2.66667 27.5333 2.66667 25.3333V6.66667C2.66667 4.46667 4.46667 2.66667 6.66667 2.66667H25.3333C27.5333 2.66667 29.3333 4.46667 29.3333 6.66667V20H24C21.8 20 20 21.8 20 24V29.3333H6.66667ZM24.6133 28.16C24.08 28.6933 23.4 29.0667 22.6667 29.2267V23.9867C22.6667 23.2533 23.2667 22.6533 24 22.6533H29.24C29.08 23.3867 28.7067 24.0667 28.1733 24.6L24.6267 28.1467L24.6133 28.16Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_322_641">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RulerIcons = ({
  width = 32,
  height = 32,
  fill = "var(--primary-color)",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.01866 19.0195L20.1389 5.68537C21.1669 4.71467 21.4616 3.32318 20.9031 2.05752C20.348 0.78935 19.1003 0.00195304 17.6461 0.00195298L4.41798 0.00195243C1.98166 0.00195233 -0.000217524 1.87337 -0.000217631 4.1739L-0.000218209 16.6648C-0.000218273 18.0362 0.833652 19.2153 2.17667 19.7402C3.51969 20.2651 4.99066 19.9893 6.01866 19.0195ZM2.85083 18.2021C2.1705 17.9354 1.76459 17.3613 1.76459 16.6656L1.76459 4.1739C1.76459 2.79242 2.95495 1.6684 4.41798 1.6684L17.6461 1.6684C18.3829 1.6684 18.9909 2.05168 19.2733 2.69493C19.3686 2.9124 19.4153 3.13321 19.4153 3.35068C19.4153 3.77479 19.2362 4.18224 18.8912 4.50719L17.4696 5.84952L15.786 4.25973C15.441 3.93394 14.8833 3.93394 14.5383 4.25973C14.3662 4.42221 14.2797 4.63551 14.2797 4.84882C14.2797 5.06212 14.3662 5.27543 14.5383 5.43791L16.2219 7.0277L14.9283 8.2492L13.2447 6.65941C12.8996 6.33362 12.342 6.33362 11.9969 6.65941C11.8249 6.82189 11.7384 7.03519 11.7384 7.2485C11.7384 7.46181 11.8249 7.67511 11.9969 7.83759L13.6806 9.42738L12.4329 10.6064L10.7492 9.0166C10.4042 8.69081 9.84653 8.69081 9.50151 9.0166C9.32944 9.17908 9.24297 9.39238 9.24297 9.60569C9.24297 9.819 9.32944 10.0323 9.50151 10.1948L11.1851 11.7846L9.93742 12.9627L8.25379 11.373C7.90877 11.0472 7.35109 11.0472 7.00607 11.373C6.834 11.5354 6.74753 11.7487 6.74753 11.962C6.74753 12.1754 6.834 12.3887 7.00607 12.5511L8.6897 14.1409L7.44198 15.3191L5.75835 13.7293C5.41333 13.4035 4.85565 13.4035 4.51063 13.7293C4.33856 13.8918 4.25209 14.1051 4.25209 14.3184C4.25209 14.5317 4.33856 14.745 4.51063 14.9075L6.19426 16.4973L4.77271 17.8396C4.2512 18.3312 3.53381 18.4662 2.85259 18.2004L2.85083 18.2021ZM6.80047 8.92411C6.5481 9.16241 6.16867 9.23407 5.83865 9.10492C5.50863 8.97577 5.29421 8.67165 5.29421 8.33502L5.29421 5.83535C5.29421 5.37541 5.68864 5.00213 6.17661 5.00213L8.82382 5.00213C9.18031 5.00213 9.50327 5.20544 9.63916 5.51623C9.77682 5.82785 9.70005 6.18614 9.44768 6.42444L6.80047 8.92411Z"
        fill={fill}
      />
      <path
        d="M21.2165 7.93533L6.3903 20.6027C5.3109 21.5249 5.00144 22.8468 5.58793 24.0492C6.17071 25.2539 7.48082 26.002 9.00773 26.002L22.8973 26.002C25.4554 26.002 27.5364 24.2241 27.5364 22.0386L27.5364 10.1723C27.5364 8.86937 26.6608 7.74931 25.2506 7.25063C23.8405 6.75194 22.2959 7.01395 21.2165 7.93533ZM24.5428 8.71185C25.2571 8.96515 25.6833 9.51054 25.6833 10.1715L25.6833 22.0386C25.6833 23.351 24.4334 24.4188 22.8973 24.4188L9.00773 24.4188C8.23408 24.4188 7.5957 24.0547 7.29922 23.4436C7.19915 23.237 7.15005 23.0273 7.15005 22.8207C7.15005 22.4178 7.33813 22.0307 7.7004 21.722L9.19303 20.4468L10.9608 21.9571C11.3231 22.2666 11.9087 22.2666 12.2709 21.9571C12.4516 21.8027 12.5424 21.6001 12.5424 21.3974C12.5424 21.1948 12.4516 20.9922 12.2709 20.8378L10.5031 19.3275L11.8614 18.1671L13.6292 19.6774C13.9915 19.9869 14.5771 19.9869 14.9393 19.6774C15.12 19.523 15.2108 19.3204 15.2108 19.1177C15.2108 18.9151 15.12 18.7125 14.9393 18.5581L13.1715 17.0478L14.4816 15.9277L16.2494 17.438C16.6117 17.7475 17.1973 17.7475 17.5595 17.438C17.7402 17.2837 17.831 17.081 17.831 16.8784C17.831 16.6758 17.7402 16.4731 17.5595 16.3188L15.7917 14.8085L17.1018 13.6892L18.8697 15.1995C19.2319 15.509 19.8175 15.509 20.1798 15.1995C20.3604 15.0451 20.4512 14.8425 20.4512 14.6399C20.4512 14.4372 20.3604 14.2346 20.1798 14.0802L18.412 12.5699L19.7221 11.4507L21.4899 12.961C21.8521 13.2705 22.4377 13.2705 22.8 12.961C22.9806 12.8066 23.0714 12.604 23.0714 12.4013C23.0714 12.1987 22.9806 11.996 22.8 11.8417L21.0322 10.3314L22.5248 9.05618C23.0724 8.58916 23.8256 8.46093 24.5409 8.71343L24.5428 8.71185ZM20.3956 17.5259C20.6606 17.2995 21.059 17.2314 21.4056 17.3541C21.7521 17.4768 21.9772 17.7657 21.9772 18.0855L21.9772 20.4602C21.9772 20.8972 21.5631 21.2518 21.0507 21.2518L18.2711 21.2518C17.8968 21.2518 17.5577 21.0586 17.415 20.7634C17.2705 20.4673 17.3511 20.127 17.6161 19.9006L20.3956 17.5259Z"
        fill={fill}
      />
    </svg>
  );
};

export const DocumentIcon = ({
  width = 32,
  height = 32,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 54 54"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_190_1179)">
        <path
          d="M38.25 31.5001C38.25 32.0968 38.0129 32.6691 37.591 33.091C37.169 33.513 36.5967 33.7501 36 33.7501H18C17.4033 33.7501 16.831 33.513 16.409 33.091C15.9871 32.6691 15.75 32.0968 15.75 31.5001C15.75 30.9033 15.9871 30.331 16.409 29.9091C16.831 29.4871 17.4033 29.2501 18 29.2501H36C36.5967 29.2501 37.169 29.4871 37.591 29.9091C38.0129 30.331 38.25 30.9033 38.25 31.5001ZM29.25 38.2501H18C17.4033 38.2501 16.831 38.4871 16.409 38.9091C15.9871 39.331 15.75 39.9033 15.75 40.5001C15.75 41.0968 15.9871 41.6691 16.409 42.091C16.831 42.513 17.4033 42.7501 18 42.7501H29.25C29.8467 42.7501 30.419 42.513 30.841 42.091C31.2629 41.6691 31.5 41.0968 31.5 40.5001C31.5 39.9033 31.2629 39.331 30.841 38.9091C30.419 38.4871 29.8467 38.2501 29.25 38.2501ZM49.5 23.5913V42.7501C49.4964 45.7326 48.31 48.592 46.201 50.7011C44.092 52.8101 41.2326 53.9965 38.25 54.0001H15.75C12.7674 53.9965 9.90801 52.8101 7.79899 50.7011C5.68998 48.592 4.50357 45.7326 4.5 42.7501V11.2501C4.50357 8.26746 5.68998 5.40806 7.79899 3.29905C9.90801 1.19004 12.7674 0.00362454 15.75 5.18595e-05H25.9088C27.9779 -0.00527372 30.0276 0.399624 31.9393 1.19134C33.8509 1.98305 35.5867 3.14586 37.0462 4.61255L44.8853 12.4561C46.3528 13.9146 47.5163 15.6498 48.3085 17.5612C49.1006 19.4727 49.5056 21.5223 49.5 23.5913ZM33.8647 7.79405C33.1566 7.10816 32.3616 6.51813 31.5 6.03905V15.7501C31.5 16.3468 31.7371 16.9191 32.159 17.341C32.581 17.763 33.1533 18.0001 33.75 18.0001H43.461C42.9817 17.1387 42.3908 16.3444 41.7038 15.6376L33.8647 7.79405ZM45 23.5913C45 23.2201 44.928 22.8646 44.8942 22.5001H33.75C31.9598 22.5001 30.2429 21.7889 28.977 20.523C27.7112 19.2572 27 17.5403 27 15.7501V4.6058C26.6355 4.57205 26.2778 4.50005 25.9088 4.50005H15.75C13.9598 4.50005 12.2429 5.21121 10.977 6.47708C9.71116 7.74295 9 9.45984 9 11.2501V42.7501C9 44.5403 9.71116 46.2572 10.977 47.523C12.2429 48.7889 13.9598 49.5 15.75 49.5001H38.25C40.0402 49.5 41.7571 48.7889 43.023 47.523C44.2888 46.2572 45 44.5403 45 42.7501V23.5913Z"
          fill="#E6E6E6"
        />
      </g>
      <defs>
        <clipPath id="clip0_190_1179">
          <rect width="54" height="54" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PinIcon = ({
  width = 37,
  height = 44,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 44"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2645 0C13.4221 0.00531788 8.77952 1.93131 5.35542 5.35542C1.93131 8.77952 0.00531788 13.4221 0 18.2645C0 27.9118 15.3422 41.1554 17.0846 42.6348L18.2645 43.632L19.4444 42.6348C21.1868 41.1554 36.529 27.9118 36.529 18.2645C36.5236 13.4221 34.5976 8.77952 31.1735 5.35542C27.7494 1.93131 23.1069 0.00531788 18.2645 0ZM18.2645 27.3967C16.4583 27.3967 14.6927 26.8611 13.1909 25.8577C11.6891 24.8542 10.5186 23.4279 9.82739 21.7592C9.13619 20.0905 8.95534 18.2544 9.30771 16.4829C9.66008 14.7114 10.5298 13.0842 11.807 11.807C13.0842 10.5298 14.7114 9.66008 16.4829 9.30771C18.2544 8.95534 20.0905 9.13619 21.7592 9.82739C23.4279 10.5186 24.8542 11.6891 25.8577 13.1909C26.8611 14.6927 27.3967 16.4583 27.3967 18.2645C27.3938 20.6856 26.4307 23.0067 24.7187 24.7187C23.0067 26.4307 20.6856 27.3938 18.2645 27.3967Z"
        fill={fill}
      />
    </svg>
  );
};

export const ViewIcon = ({
  width = 18,
  height = 18,
  fill = "var(--bs-warning)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Outline"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      className="action-icon"
    >
      <path d="M23.271,9.419C21.72,6.893,18.192,2.655,12,2.655S2.28,6.893.729,9.419a4.908,4.908,0,0,0,0,5.162C2.28,17.107,5.808,21.345,12,21.345s9.72-4.238,11.271-6.764A4.908,4.908,0,0,0,23.271,9.419Zm-1.705,4.115C20.234,15.7,17.219,19.345,12,19.345S3.766,15.7,2.434,13.534a2.918,2.918,0,0,1,0-3.068C3.766,8.3,6.781,4.655,12,4.655s8.234,3.641,9.566,5.811A2.918,2.918,0,0,1,21.566,13.534Z" />
      <path d="M12,7a5,5,0,1,0,5,5A5.006,5.006,0,0,0,12,7Zm0,8a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z" />
    </svg>
  );
};

export const EditIcon = ({
  width = 18,
  height = 18,
  fill = "var(--bs-primary)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      className="action-icon"
    >
      <path d="m18.813,10c.309,0,.601-.143.79-.387s.255-.562.179-.861c-.311-1.217-.945-2.329-1.833-3.217l-3.485-3.485c-1.322-1.322-3.08-2.05-4.95-2.05h-4.515C2.243,0,0,2.243,0,5v14c0,2.757,2.243,5,5,5h3c.552,0,1-.448,1-1s-.448-1-1-1h-3c-1.654,0-3-1.346-3-3V5c0-1.654,1.346-3,3-3h4.515c.163,0,.325.008.485.023v4.977c0,1.654,1.346,3,3,3h5.813Zm-6.813-3V2.659c.379.218.732.488,1.05.806l3.485,3.485c.314.314.583.668.803,1.05h-4.338c-.551,0-1-.449-1-1Zm11.122,4.879c-1.134-1.134-3.11-1.134-4.243,0l-6.707,6.707c-.755.755-1.172,1.76-1.172,2.829v1.586c0,.552.448,1,1,1h1.586c1.069,0,2.073-.417,2.828-1.172l6.707-6.707c.567-.567.879-1.32.879-2.122s-.312-1.555-.878-2.121Zm-1.415,2.828l-6.708,6.707c-.377.378-.879.586-1.414.586h-.586v-.586c0-.534.208-1.036.586-1.414l6.708-6.707c.377-.378,1.036-.378,1.414,0,.189.188.293.439.293.707s-.104.518-.293.707Z" />
    </svg>
  );
};

export const DeleteIcon = ({
  width = 18,
  height = 18,
  fill = "var(--bs-danger)",
  onClick,
}: IProps) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      id="Outline"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      className="action-icon"
    >
      <path d="M21,4H17.9A5.009,5.009,0,0,0,13,0H11A5.009,5.009,0,0,0,6.1,4H3A1,1,0,0,0,3,6H4V19a5.006,5.006,0,0,0,5,5h6a5.006,5.006,0,0,0,5-5V6h1a1,1,0,0,0,0-2ZM11,2h2a3.006,3.006,0,0,1,2.829,2H8.171A3.006,3.006,0,0,1,11,2Zm7,17a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3V6H18Z" />
      <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18Z" />
      <path d="M14,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z" />
    </svg>
  );
};

export const CopyIcon = ({
  width = 18,
  height = 18,
  fill = "var(--secondary-color)",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className="action-icon"
    >
      <g clipPath="url(#clip0_597_934)">
        <path d="M8.66683 13.3333C9.55056 13.3323 10.3978 12.9808 11.0227 12.3559C11.6476 11.731 11.9991 10.8837 12.0002 10V4.16201C12.0012 3.81158 11.9327 3.46444 11.7986 3.14069C11.6644 2.81694 11.4674 2.52304 11.2188 2.27601L9.72416 0.781345C9.47714 0.532794 9.18323 0.335747 8.85948 0.201625C8.53574 0.0675033 8.18859 -0.0010253 7.83816 1.15931e-05H4.66683C3.7831 0.00107016 2.93587 0.3526 2.31098 0.977492C1.68608 1.60238 1.33455 2.44961 1.3335 3.33334V10C1.33455 10.8837 1.68608 11.731 2.31098 12.3559C2.93587 12.9808 3.7831 13.3323 4.66683 13.3333H8.66683ZM2.66683 10V3.33334C2.66683 2.80291 2.87754 2.2942 3.25262 1.91913C3.62769 1.54406 4.1364 1.33334 4.66683 1.33334C4.66683 1.33334 7.94616 1.34268 8.00016 1.34934V2.66668C8.00016 3.0203 8.14064 3.35944 8.39069 3.60949C8.64074 3.85954 8.97988 4.00001 9.3335 4.00001H10.6508C10.6575 4.05401 10.6668 10 10.6668 10C10.6668 10.5304 10.4561 11.0392 10.081 11.4142C9.70597 11.7893 9.19726 12 8.66683 12H4.66683C4.1364 12 3.62769 11.7893 3.25262 11.4142C2.87754 11.0392 2.66683 10.5304 2.66683 10ZM14.6668 5.33334V12.6667C14.6658 13.5504 14.3142 14.3976 13.6894 15.0225C13.0645 15.6474 12.2172 15.999 11.3335 16H5.3335C5.15669 16 4.98712 15.9298 4.86209 15.8048C4.73707 15.6797 4.66683 15.5102 4.66683 15.3333C4.66683 15.1565 4.73707 14.987 4.86209 14.8619C4.98712 14.7369 5.15669 14.6667 5.3335 14.6667H11.3335C11.8639 14.6667 12.3726 14.456 12.7477 14.0809C13.1228 13.7058 13.3335 13.1971 13.3335 12.6667V5.33334C13.3335 5.15653 13.4037 4.98696 13.5288 4.86194C13.6538 4.73692 13.8234 4.66668 14.0002 4.66668C14.177 4.66668 14.3465 4.73692 14.4716 4.86194C14.5966 4.98696 14.6668 5.15653 14.6668 5.33334Z" />
      </g>
      <defs>
        <clipPath id="clip0_597_934">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UploadIcon = ({
  width = 16,
  height = 16,
  fill = "var(--secondary-color)",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9827 3.764C11.762 3.72 11.5813 3.582 11.488 3.38466C10.4547 1.204 8.05933 -0.0153351 5.66533 0.425998C3.484 0.825998 1.774 2.56733 1.40933 4.76C1.30133 5.40733 1.30933 6.05533 1.43133 6.68666C1.47133 6.89266 1.38267 7.122 1.20067 7.28733C0.437333 7.98133 0 8.97 0 10.0007C0 12.022 1.64467 13.6673 3.66667 13.6673H11C13.7573 13.6673 16 11.4247 16 8.66733C16 6.29066 14.3107 4.228 11.9827 3.764ZM11 12.3333H3.66667C2.38 12.3333 1.33333 11.2867 1.33333 10C1.33333 9.34466 1.612 8.71466 2.09733 8.27333C2.62133 7.79666 2.86733 7.09133 2.73933 6.43133C2.64733 5.95666 2.642 5.468 2.72333 4.97733C2.992 3.36266 4.3 2.03 5.904 1.736C6.16067 1.68933 6.416 1.66666 6.668 1.66666C8.20933 1.66666 9.60467 2.526 10.2827 3.956C10.558 4.53733 11.0827 4.944 11.7213 5.07133C13.428 5.412 14.666 6.924 14.666 8.66733C14.666 10.6887 13.0207 12.334 10.9993 12.334L11 12.3333ZM10.0807 7.19533C10.3413 7.456 10.3413 7.87733 10.0807 8.138C9.95067 8.268 9.78 8.33333 9.60933 8.33333C9.43867 8.33333 9.268 8.268 9.138 8.138L8 7V10.3333C8 10.702 7.70133 11 7.33333 11C6.96533 11 6.66667 10.702 6.66667 10.3333V7L5.52867 8.138C5.268 8.39866 4.84667 8.39866 4.586 8.138C4.32533 7.87733 4.32533 7.456 4.586 7.19533L6.39067 5.39066C6.648 5.13333 6.986 5.004 7.324 5.002L7.33333 5L7.34267 5.002C7.68133 5.004 8.01867 5.13333 8.276 5.39066L10.0807 7.19533Z"
        fill="white"
      />
    </svg>
  );
};

export const SaveIcon = ({
  width = 18,
  height = 18,
  fill = "var(--secondary-color)",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1132_1603)">
        <path
          d="M8.49968 7.20532C7.97226 7.20532 7.45669 7.36172 7.01816 7.65474C6.57962 7.94775 6.23783 8.36423 6.036 8.8515C5.83416 9.33877 5.78135 9.87495 5.88425 10.3922C5.98714 10.9095 6.24112 11.3847 6.61406 11.7576C6.987 12.1305 7.46215 12.3845 7.97944 12.4874C8.49672 12.5903 9.0329 12.5375 9.52017 12.3357C10.0074 12.1338 10.4239 11.792 10.7169 11.3535C11.0099 10.915 11.1663 10.3994 11.1663 9.87199C11.1663 9.16474 10.8854 8.48647 10.3853 7.98637C9.8852 7.48627 9.20692 7.20532 8.49968 7.20532ZM8.49968 11.2053C8.23597 11.2053 7.97818 11.1271 7.75892 10.9806C7.53965 10.8341 7.36875 10.6259 7.26784 10.3822C7.16692 10.1386 7.14052 9.87051 7.19196 9.61187C7.24341 9.35323 7.3704 9.11565 7.55687 8.92918C7.74334 8.74271 7.98091 8.61572 8.23956 8.56428C8.4982 8.51283 8.76629 8.53923 9.00992 8.64015C9.25356 8.74107 9.46179 8.91196 9.6083 9.13123C9.75481 9.35049 9.83301 9.60828 9.83301 9.87199C9.83301 10.2256 9.69253 10.5647 9.44248 10.8148C9.19244 11.0648 8.8533 11.2053 8.49968 11.2053Z"
          fill="white"
        />
        <path
          d="M15.524 3.28659L13.752 1.51459C13.4432 1.20415 13.076 0.95804 12.6714 0.790509C12.2669 0.622977 11.8332 0.537351 11.3953 0.538587H3.83333C2.9496 0.539646 2.10237 0.891175 1.47748 1.51607C0.852588 2.14096 0.501059 2.98819 0.5 3.87192L0.5 13.2053C0.501059 14.089 0.852588 14.9362 1.47748 15.5611C2.10237 16.186 2.9496 16.5375 3.83333 16.5386H13.1667C14.0504 16.5375 14.8976 16.186 15.5225 15.5611C16.1474 14.9362 16.4989 14.089 16.5 13.2053V5.64325C16.5012 5.20541 16.4156 4.77167 16.2481 4.36715C16.0805 3.96263 15.8344 3.59535 15.524 3.28659ZM11.8333 1.92525V2.53859C11.8333 3.06902 11.6226 3.57773 11.2475 3.9528C10.8725 4.32787 10.3638 4.53859 9.83333 4.53859H7.16667C6.63623 4.53859 6.12753 4.32787 5.75245 3.9528C5.37738 3.57773 5.16667 3.06902 5.16667 2.53859V1.87192H11.3953C11.5429 1.87323 11.6898 1.89112 11.8333 1.92525ZM15.1667 13.2053C15.1667 13.7357 14.956 14.2444 14.5809 14.6195C14.2058 14.9945 13.6971 15.2053 13.1667 15.2053H3.83333C3.3029 15.2053 2.79419 14.9945 2.41912 14.6195C2.04405 14.2444 1.83333 13.7357 1.83333 13.2053V3.87192C1.83333 3.34149 2.04405 2.83278 2.41912 2.45771C2.79419 2.08263 3.3029 1.87192 3.83333 1.87192V2.53859C3.83439 3.42232 4.18592 4.26955 4.81081 4.89444C5.43571 5.51933 6.28294 5.87086 7.16667 5.87192H9.83333C10.6717 5.86932 11.4781 5.55036 12.0914 4.97883C12.7047 4.4073 13.0797 3.62532 13.1413 2.78925L14.5813 4.22925C14.955 4.60517 15.1653 5.11325 15.1667 5.64325V13.2053Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1132_1603">
          <rect
            width={width}
            height={height}
            fill={fill}
            transform="translate(0.5 0.538574)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlusIcon = ({
  width = 14,
  height = 14,
  fill = "#fff",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.56485 0.543061L6.64258 0.538574C6.98445 0.538574 7.26625 0.795934 7.30478 1.12749L7.30925 1.20524V5.87191H11.9759C12.3178 5.87191 12.5996 6.12924 12.6381 6.46084L12.6426 6.53857C12.6426 6.88044 12.3852 7.16224 12.0536 7.20077L11.9759 7.20524H7.30925V11.8719C7.30925 12.2138 7.05191 12.4956 6.72031 12.5341L6.64258 12.5386C6.30071 12.5386 6.01891 12.2812 5.98038 11.9496L5.97591 11.8719V7.20524H1.30924C0.967351 7.20524 0.685572 6.94791 0.647065 6.61631L0.642578 6.53857C0.642578 6.19671 0.899938 5.91491 1.2315 5.87637L1.30924 5.87191H5.97591V1.20524C5.97591 0.863348 6.23324 0.581568 6.56485 0.543061Z"
        fill={fill}
      />
    </svg>
  );
};

export const CheckIcon = ({
  width = 14,
  height = 14,
  fill = "#fff",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Outline"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
    >
      <path d="M22.319,4.431,8.5,18.249a1,1,0,0,1-1.417,0L1.739,12.9a1,1,0,0,0-1.417,0h0a1,1,0,0,0,0,1.417l5.346,5.345a3.008,3.008,0,0,0,4.25,0L23.736,5.847a1,1,0,0,0,0-1.416h0A1,1,0,0,0,22.319,4.431Z" />
    </svg>
  );
};

export const BellIcon = ({
  width = 14,
  height = 14,
  fill = "#fff",
  isAnimated = false,
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`header-link-icon ${isAnimated ? "animate-bell" : ""}`}
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <path
        d="M96,192a32,32,0,0,0,64,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      ></path>
      <path
        d="M184,24a102.71,102.71,0,0,1,36.29,40"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      ></path>
      <path
        d="M35.71,64A102.71,102.71,0,0,1,72,24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      ></path>
      <path
        d="M56,112a72,72,0,0,1,144,0c0,35.82,8.3,56.6,14.9,68A8,8,0,0,1,208,192H48a8,8,0,0,1-6.88-12C47.71,168.6,56,147.81,56,112Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      ></path>
    </svg>
  );
};

export const LanguageIcon = ({
  width = 14,
  height = 14,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="header-link-icon"
      viewBox="0 0 256 256"
    >
      <rect width={256} height={256} fill="none" />
      <polyline
        points="240 216 184 104 128 216"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <line
        x1={144}
        y1={184}
        x2={224}
        y2={184}
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <line
        x1={96}
        y1={32}
        x2={96}
        y2={56}
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <line
        x1={32}
        y1={56}
        x2={160}
        y2={56}
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <path
        d="M128,56a96,96,0,0,1-96,96"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <path
        d="M69.47,88A96,96,0,0,0,160,152"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </svg>
  );
};

export const ThemeIcon = ({
  width = 14,
  height = 14,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="header-link-icon"
      viewBox="0 0 256 256"
    >
      <rect width={256} height={256} fill="none" />
      <path
        d="M108.11,28.11A96.09,96.09,0,0,0,227.89,147.89,96,96,0,1,1,108.11,28.11Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </svg>
  );
};
export const DownloadIcon = ({
  width = 16,
  height = 16,
  fill = "currentColor",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z" />
    </svg>
  );
};

export const VisitsIcon = ({
  width = 20,
  height = 20,
  fill = "var(--menu-prime-color)",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
    >
      <path d="M19,3h-1V2c0-.552-.448-1-1-1s-1,.448-1,1v1H8V2c0-.552-.448-1-1-1s-1,.448-1,1v1h-1C2.243,3,0,5.243,0,8v11c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V8c0-2.757-2.243-5-5-5Zm3,16c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3v-9h20v9ZM2,8c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3H2Z" />
      <path d="M12,12c-1.657,0-3,1.343-3,3,0,1.933,3,5,3,5,0,0,3-3.067,3-5,0-1.657-1.343-3-3-3Zm0,4c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Z" />
    </svg>
  );
};
